<form [formGroup]="contactForm" class="download-form" (submit)="onSubmit()">
  <!-- Prenom & Nom -->
  <div
    class="form-group-wrapper"
    fxLayout="row"
    fxLayout.lt-sm="column"
    fxLayoutAlign="space-between start"
    fxLayoutGap="1em"
    fxLayoutGap.lt-sm="0"
  >
    <div class="form-group">
      <label for="" class="form-label">Prénom<sup>*</sup></label>
      <mat-form-field appearance="outline" class="w-100">
        <input matInput placeholder="" formControlName="firstnameControl" />
        <mat-error
          *ngIf="
            contactForm.get('firstnameControl').touched && contactForm.get('firstnameControl').hasError('required')
          "
          >Veuillez remplir ce champ obligatoire</mat-error
        >
      </mat-form-field>
    </div>
    <div class="form-group">
      <label for="" class="form-label">Nom<sup>*</sup></label>
      <mat-form-field appearance="outline" class="w-100">
        <input matInput placeholder="" formControlName="lastnameControl" />
        <mat-error
          *ngIf="contactForm.get('lastnameControl').touched && contactForm.get('lastnameControl').hasError('required')"
          >Veuillez remplir ce champ obligatoire</mat-error
        >
      </mat-form-field>
    </div>
  </div>
  <!-- E-mail Pro & Tel Pro -->
  <div
    class="form-group-wrapper"
    fxLayout="row"
    fxLayout.lt-sm="column"
    fxLayoutAlign="space-between start"
    fxLayoutGap="1em"
    fxLayoutGap.lt-sm="0"
  >
    <div class="form-group">
      <label for="" class="form-label">E-mail professionnel<sup>*</sup></label>
      <mat-form-field appearance="outline" class="w-100">
        <input matInput placeholder="" formControlName="emailProControl" />
        <mat-error
          *ngIf="contactForm.get('emailProControl').touched && contactForm.get('emailProControl').hasError('required')"
          >Veuillez remplir ce champ obligatoire</mat-error
        >
        <mat-error
          *ngIf="
            !contactForm.get('emailProControl').hasError('required') &&
            contactForm.get('emailProControl').hasError('validEmailPro')
          "
          >Merci de renseigner un email professionnel</mat-error
        >
      </mat-form-field>
    </div>
    <div class="form-group">
      <label for="" class="form-label">Numéro de téléphone<sup>*</sup></label>
      <mat-form-field appearance="outline" class="w-100">
        <input matInput placeholder="" formControlName="telProControl" />
        <mat-error
          *ngIf="contactForm.get('telProControl').touched && contactForm.get('telProControl').hasError('required')"
          >Veuillez remplir ce champ obligatoire</mat-error
        >
        <mat-error
          *ngIf="
            !contactForm.get('telProControl').hasError('required') &&
            contactForm.get('telProControl').hasError('pattern')
          "
          >Numéro non valide</mat-error
        >
      </mat-form-field>
    </div>
  </div>
  <!-- Company Name -->
  <div
    class="form-group-wrapper"
    fxLayout="row"
    fxLayout.lt-sm="column"
    fxLayoutAlign="space-between start"
    fxLayoutGap="1em"
    fxLayoutGap.lt-sm="0"
  >
    <div class="form-group">
      <label for="" class="form-label">Nom de l'entreprise<sup>*</sup></label>
      <mat-form-field appearance="outline" class="w-100">
        <input matInput placeholder="" formControlName="companyControl" />
        <mat-error
          *ngIf="contactForm.get('companyControl').touched && contactForm.get('companyControl').hasError('required')"
          >Veuillez remplir ce champ obligatoire</mat-error
        >
      </mat-form-field>
    </div>
  </div>
  <div class="form-check mb-4">
    <mat-checkbox formControlName="agreeControl">
      <span class="form-check-label">{{ agree.agreeText }}</span>
    </mat-checkbox>
    <mat-hint class="form-text text-justify">{{ agree.agreeDescription }}</mat-hint>
  </div>

  <div class="form-action">
    <button
      class="btn btn-rounded btn-action btn-lg"
      [disabled]="!contactForm.valid && contactForm.get('agreeControl').value === false"
    >
      <span>Télécharger</span>
    </button>
  </div>
</form>
